import { render, staticRenderFns } from "./SplitModal.vue?vue&type=template&id=2acfc8bd&"
import script from "./SplitModal.vue?vue&type=script&lang=js&"
export * from "./SplitModal.vue?vue&type=script&lang=js&"
import style0 from "./SplitModal.vue?vue&type=style&index=0&id=2acfc8bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports